import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row, Popover } from 'antd';
import { Form, Field } from 'redux-form';
import { TextField } from 'redux-form-antd';
import isEmpty from 'lodash/isEmpty';

import './index.css';
import AppTemplate from '../../templates/AppTemplate';
import BigQueryModal from '../../../containers/BigQueryModal';
import InlineMessage from '../../atoms/InlineMessage';
import FormValueSelector from '../../../containers/FormValueSelector';

const formItemLayoutInline = {
  colon: false,
  labelCol: {
    xs: { span: 12 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 12 },
    sm: { span: 13 },
  },
};

const Audiences = ({
  isPolling,
  handleSubmit,
  checkResponse,
  deviceGroupName,
  deviceCount,
  showBigQueryModal,
  submitting,
}) => (
  <AppTemplate>
    <div className="im-audiences-container">
      <Row>
        <Col span={24}>
          <h1>Audiences</h1>
        </Col>
      </Row>
      <div className="im-audiences">
        {!isEmpty(checkResponse) && (
          <InlineMessage
            style={{ marginBottom: 20 }}
            message={
              checkResponse.attemptedItems === checkResponse.totalRowsInQuery
                ? `Success! Your group: ${checkResponse.deviceGroupName} with ${checkResponse.uniqueDeviceCount} devices has been uploaded.`
                : `Uploading. ${checkResponse.attemptedItems.toLocaleString()}/${checkResponse.totalRowsInQuery.toLocaleString()} devices remaining.`
            }
            type={
              checkResponse.attemptedItems !== checkResponse.totalRowsInQuery ? 'info' : 'success'
            }
          />
        )}

        <Form onSubmit={handleSubmit}>
          <Row>
            <Col span={24}>
              <Field
                {...formItemLayoutInline}
                labelCol={{ ...formItemLayoutInline.labelCol, sm: { span: 5 } }}
                label="Device Group Name"
                name="deviceGroupName"
                component={TextField}
                style={{ marginBottom: 0 }}
                maxLength={256}
              />
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Field
                {...formItemLayoutInline}
                labelCol={{ ...formItemLayoutInline.labelCol, sm: { span: 10 } }}
                label="Advertiser ID"
                name="advertiserId"
                component={TextField}
                style={{ marginBottom: 0 }}
                maxLength={256}
              />
            </Col>
            <Col span={12}>
              <Popover
                placement="topLeft"
                content={
                  <div>
                    Find the Advertiser id in the URL of the Advertiser detail page
                    <br />
                    in The Trade Desk
                    <br />{' '}
                    <a
                      href="https://desk.thetradedesk.com/Advertisers/Detail/git8gaq"
                      target=" _blank"
                    >
                      https://desk.thetradedesk.com/Advertisers/Detail/
                      <strong>git8gaq</strong>
                    </a>
                  </div>
                }
                trigger="hover"
              >
                <Button type="primary" shape="circle" icon="question" style={{ marginTop: 3 }} />
              </Popover>
            </Col>
          </Row>
          <Row display="flex" justify="left" align="middle">
            <Col offset={5} span={19} style={{ marginBottom: 20 }}>
              <div>
                <Button onClick={showBigQueryModal} disabled={submitting || isPolling}>
                  {deviceCount ? 'View/Edit Query' : 'Create Device Targeting Query'}
                </Button>
                <h2 style={{ marginLeft: 10, display: 'inline' }}>
                  <em>{deviceCount.toLocaleString() || 0} Devices</em>
                </h2>
              </div>
              <FormValueSelector fieldName="query">
                {query =>
                  isEmpty(query) ? (
                    <div className="has-error">
                      <p className="ant-form-explain">Cannot be blank</p>
                    </div>
                  ) : null
                }
              </FormValueSelector>
            </Col>
          </Row>
          <Row>
            <Col span={24} align="right">
              <Button
                type="primary"
                size="large"
                disabled={!deviceCount}
                loading={submitting || isPolling}
                onClick={handleSubmit}
                style={{ marginTop: 20 }}
              >
                Send to the Trade Desk
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
      <BigQueryModal />
    </div>
  </AppTemplate>
);

Audiences.defaultProps = {
  submitting: false,
};

Audiences.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  showBigQueryModal: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
};

export default Audiences;
